import {useAuthContext} from '../context/AuthContext';

interface AuthenticatedTemplateProps {
    children?: React.ReactNode;
}

export const AuthenticatedTemplate: React.FC<AuthenticatedTemplateProps> = ({
    children
}) => {
    const {isAuthenticated} = useAuthContext();

    if (isAuthenticated) {
        return <>{children}</>;
    }
    return <></>;
};
